
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Downloads"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":117}};
    doc.loc.source = {"body":"#import \"./download.gql\"\n\nfragment DownloadsFields on Downloads {\n  items {\n    ...DownloadFields\n  }\n  totalItems\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./download.gql").definitions));


      module.exports = doc;
    
